import { createStyles } from '../../core/withStyles';
import { tab } from '../../mixins';
const styles = (theme) => createStyles({
    root: Object.assign(Object.assign({}, tab(theme)), { alignItems: 'flex-start', padding: `${theme.spacing(1.5)}px ${theme.spacing(10)}px`, color: theme.menu.foreground, fontSize: theme.fontSizes.sm, border: 0 }),
    active: {
        fontWeight: 500,
    },
});
export default styles;
//# sourceMappingURL=MenuDrawerItem.styles.js.map